export default __webpack_public_path__ + "static/media/emotionalIntelligence@3x.942ed2e8.png";